import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'stripHtml',
  standalone: true // Use standalone if you are on Angular 14+, otherwise declare in NgModule
})
export class StripHtmlPipe implements PipeTransform {

  transform(value: string): string {
    if (!value) return '';

    // Method 1: Regex (Fastest for simple tags)
    // Replaces any tag <> with an empty string
    return value.replace(/<[^>]*>/g, '');

    // Method 2: Browser Parser (Better for encoded entities like &nbsp;)
    // const tempDiv = document.createElement('div');
    // tempDiv.innerHTML = value;
    // return tempDiv.textContent || tempDiv.innerText || '';
  }

}
